import React from 'react';
import NavBar from '../components/Navbar/NavBar';
import PrivacyPolicy from '../components/PrivacyPolicy';


const Privacy = () => {
    return (
        <>
            <NavBar/>
            <PrivacyPolicy />
        </>

    )
}

export default Privacy;

